export type PageUrlsConfig = {
  sr: {
    WISH_LIST: string;
    INSURANCE: string;
    ADDITIONAL_PRODUCTS: string;
    ADDITIONAL_PRODUCTS_ALL: string;
    CONTRACTS: string;
    EXISTING_CUSTOMER: string;
    MNP: string;
    FNP: string;
    PREPAID_REGISTRATION: string;
    PREPAID_REGISTRATION_CONSUMER: string;
    PREPAID_REGISTRATION_BUSINESS: string;
    PREPAID_REGISTRATION_BUSINESS_RESULTS: string;
    PREPAID_REGISTRATION_REDIRECT: string;
    PREPAID_REGISTRATION_ERROR: string;
    PREPAID_REGISTRATION_SUCCESS: string;
    PREPAID_REGISTRATION_EID: string;
    PREPAID_REGISTRATION_EID_COMPLETE: string;
  };
  en: {
    WISH_LIST: string;
    INSURANCE: string;
    ADDITIONAL_PRODUCTS: string;
    ADDITIONAL_PRODUCTS_ALL: string;
    CONTRACTS: string;
    EXISTING_CUSTOMER: string;
    MNP: string;
    FNP: string;
    PREPAID_REGISTRATION: string;
    PREPAID_REGISTRATION_CONSUMER: string;
    PREPAID_REGISTRATION_BUSINESS: string;
    PREPAID_REGISTRATION_BUSINESS_RESULTS: string;
    PREPAID_REGISTRATION_REDIRECT: string;
    PREPAID_REGISTRATION_ERROR: string;
    PREPAID_REGISTRATION_SUCCESS: string;
    PREPAID_REGISTRATION_EID: string;
    PREPAID_REGISTRATION_EID_COMPLETE: string;
  };
};

export const PageUrls: PageUrlsConfig & {
  [key: string]: { [key: string]: string };
} = {
  sr: {
    WISH_LIST: 'Lista-zelja',
    INSURANCE: 'osiguranje',
    ADDITIONAL_PRODUCTS: 'Dodaci',
    ADDITIONAL_PRODUCTS_ALL: 'Svi-dodaci',
    CONTRACTS: 'Ugovori',
    EXISTING_CUSTOMER: 'Postojeci-korisnik',
    MNP: 'mnp',
    FNP: 'fnp',
    PREPAID_REGISTRATION: 'prepaid-registration',
    PREPAID_REGISTRATION_CONSUMER: 'consumer',
    PREPAID_REGISTRATION_BUSINESS: 'business',
    PREPAID_REGISTRATION_BUSINESS_RESULTS: 'search-results',
    PREPAID_REGISTRATION_REDIRECT: 'redirect',
    PREPAID_REGISTRATION_ERROR: 'error',
    PREPAID_REGISTRATION_SUCCESS: 'success',
    PREPAID_REGISTRATION_EID: 'eid',
    PREPAID_REGISTRATION_EID_COMPLETE: 'complete',
  },
  en: {
    WISH_LIST: 'Wish-list',
    INSURANCE: 'insurance',
    ADDITIONAL_PRODUCTS: 'Additional-products',
    ADDITIONAL_PRODUCTS_ALL: 'All-additional-products',
    CONTRACTS: 'Contracts',
    EXISTING_CUSTOMER: 'Existing-customer',
    MNP: 'mnp',
    FNP: 'fnp',
    PREPAID_REGISTRATION: 'prepaid-registration',
    PREPAID_REGISTRATION_CONSUMER: 'consumer',
    PREPAID_REGISTRATION_BUSINESS: 'business',
    PREPAID_REGISTRATION_BUSINESS_RESULTS: 'search-results',
    PREPAID_REGISTRATION_REDIRECT: 'redirect',
    PREPAID_REGISTRATION_ERROR: 'error',
    PREPAID_REGISTRATION_SUCCESS: 'success',
    PREPAID_REGISTRATION_EID: 'eid',
    PREPAID_REGISTRATION_EID_COMPLETE: 'complete',
  },
};

export default PageUrls;
